/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * YouTube 공개 상태 (public: 전체 공개, unlisted: 일부 공개, private: 비공개)

* `public` - 전체 공개
* `unlisted` - 일부 공개 (링크 공유)
* `private` - 비공개
 */
export type Enum26fa2c9f = (typeof Enum26fa2c9f)[keyof typeof Enum26fa2c9f];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Enum26fa2c9f = {
  public: "public",
  unlisted: "unlisted",
  private: "private",
} as const;
